import type { Intake, IntakeItem, NutritionPanel, Nutrient } from '../types'
import { NUTRIENTS } from '../types'

export const NUTRIENT_LABELS: Record<Nutrient, { label: string; unit: string }> = {
  calories: { label: 'Calories', unit: 'kcal' },
  protein: { label: 'Protein', unit: 'g' },
  carbs: { label: 'Carbs', unit: 'g' },
  sugar: { label: 'Sugar', unit: 'g' },
  addedSugar: { label: 'Added sugar', unit: 'g' },
  fibre: { label: 'Fibre', unit: 'g' },
  fat: { label: 'Fat', unit: 'g' },
  saturatedFat: { label: 'Sat. fat', unit: 'g' },
  monoFat: { label: 'Monounsat. fat', unit: 'g' },
  polyFat: { label: 'Polyunsat. fat', unit: 'g' },
  transFat: { label: 'Trans fat', unit: 'g' },
  omega3: { label: 'Omega-3', unit: 'g' },
  cholesterol: { label: 'Cholesterol', unit: 'mg' },
  sodium: { label: 'Sodium', unit: 'mg' },
  potassium: { label: 'Potassium', unit: 'mg' },
  alcohol: { label: 'Alcohol', unit: 'g' },
  caffeine: { label: 'Caffeine', unit: 'mg' },
  calcium: { label: 'Calcium', unit: 'mg' },
  iron: { label: 'Iron', unit: 'mg' },
  magnesium: { label: 'Magnesium', unit: 'mg' },
  zinc: { label: 'Zinc', unit: 'mg' },
  vitA: { label: 'Vitamin A', unit: 'µg' },
  vitC: { label: 'Vitamin C', unit: 'mg' },
  vitD: { label: 'Vitamin D', unit: 'µg' },
  b12: { label: 'Vitamin B12', unit: 'µg' },
  folate: { label: 'Folate', unit: 'µg' },
}

const num = (v: unknown): number => {
  const n = Number(v)
  return Number.isFinite(n) ? n : 0
}

/** Sum a set of items and scale by servings. Total is always derived, never stored authoritatively. */
export function itemsTotal(items: IntakeItem[], servings = 1): NutritionPanel {
  const total = {} as Record<Nutrient, number>
  for (const n of NUTRIENTS) total[n] = 0
  for (const it of items) {
    for (const n of NUTRIENTS) total[n] += num((it as unknown as Record<string, unknown>)[n])
  }
  for (const n of NUTRIENTS) total[n] = total[n] * (servings || 1)
  return total as NutritionPanel
}

export function intakeTotal(intake: Intake): NutritionPanel {
  return itemsTotal(intake.items || [], intake.servings || 1)
}

/** Read one nutrient off a panel (0 when absent). */
export function nutrient(panel: NutritionPanel, key: Nutrient): number {
  return num((panel as unknown as Record<string, unknown>)[key])
}
